import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('usercentrics-supress-cmp-display', () => import(/* webpackMode: "lazy" */'./usercentrics-supress-cmp-display'));
